<div>
    {{ currentText }}
    <a class="read-option" *ngIf="text.length >= this.maxLength" [class.hidden]="hideToggle" (click)="toggleView()"><span class="read-option">Read {{isCollapsed? 'more':'less'}}</span></a>
</div>